import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { EmailIcon } from '../../../web/components/svgs/icons/EmailIcon';
import { SupportIcon } from '../../../web/components/svgs/icons/SupportIcon';
import { Dropdown, DropdownContent, DropdownItem, DropdownTrigger } from '../../../web/components-v2/Dropdown';
import { THEME } from '../../../web/components-v2/Theme/theme';
import type { NewTicketMode } from './NewTicketModal/newTicketDraft';

const styleSheet = StyleSheet.create({
	content: {
		width: 300,
		padding: THEME.spacing.xs,
	},
	item: {
		alignItems: 'flex-start',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.sm,
		borderRadius: THEME.common.borderRadius,
		// The menu shrinks any icon to 12px once an item holds child elements, which is too small to
		// read beside two lines of text.
		':has(*) svg': {
			width: 18,
			height: 18,
			marginTop: 1,
		},
	},
	text: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
	},
	title: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	description: {
		fontSize: THEME.typography.fontSizes.xs,
		lineHeight: 1.4,
		color: THEME.colors.text.light,
	},
});

interface NewTicketMenuProps {
	onSelect: (mode: NewTicketMode) => void;
	/** The control that opens the menu, e.g. the drawer's action button or the phone FAB. */
	render: React.ReactElement;
}

/** Picks the ticket mode before the dialog opens, because the two collect different fields. */
export const NewTicketMenu: React.FC<NewTicketMenuProps> = ({ onSelect, render }) => (
	<Dropdown>
		<DropdownTrigger render={render} />
		<DropdownContent align='end' styles={[styleSheet.content]}>
			<DropdownItem styles={[styleSheet.item]} onClick={() => onSelect('internal')}>
				<SupportIcon stroke={THEME.colors.icon.gray} />
				<span className={css(styleSheet.text)}>
					<span className={css(styleSheet.title)}>Internal ticket</span>
					<span className={css(styleSheet.description)}>Log an issue for the team. No email goes out.</span>
				</span>
			</DropdownItem>
			<DropdownItem styles={[styleSheet.item]} onClick={() => onSelect('outbound')}>
				<EmailIcon fillColor={THEME.colors.icon.gray} />
				<span className={css(styleSheet.text)}>
					<span className={css(styleSheet.title)}>Email a customer</span>
					<span className={css(styleSheet.description)}>Start an outbound thread. Opens the composer.</span>
				</span>
			</DropdownItem>
		</DropdownContent>
	</Dropdown>
);
